import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatAccordion } from "@angular/material/expansion";
import { ActivatedRoute, Router } from "@angular/router";
import { NGXLogger } from "ngx-logger";
import { ToastrService } from "ngx-toastr";
import { Subscription, interval } from 'rxjs';
import { ConfirmDailogueComponent } from "src/app/shared/components/dailogue/confirm-dailogue.component";
import { Api } from "src/app/shared/constants/api";
import { APP_ROUTES } from "src/app/shared/constants/approutes";
import { KEYS } from "src/app/shared/constants/keys";
import { Message } from "src/app/shared/constants/message";
import { MenuItem } from "src/app/shared/models/menu-item";
import { DataService } from "src/app/shared/services/data.service";
import { EventEmitterService } from "src/app/shared/services/event-emitter.service";
import { IUserNotificationCriteria, IUserNotificationDto } from 'src/app/user-management/user/user.interface';
import { ILoader } from '../../shared/interface';
import { CompanyBranchSelectionComponent } from "../company-branch-selection/company-branch-selection.component";
import { LayoutService } from "../layout.service";
import { LocationStrategy } from '@angular/common';
import { TrackingOutputModuleName } from 'src/app/shared/constants/trackingConstants';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { DeviceDetectorService, DeviceType } from 'src/app/shared/services/device-detector.service';
import { AppModule } from 'src/app/app.module';
import { IdleService } from 'src/app/shared/services/idle.service';

@Component({
    selector: 'cmp-sidebar-left',
    templateUrl: './sidebar-left.component.html',
    styleUrls: ['./sidebar-left-component.less'],
    standalone: false
})
export class SidebarLeftComponent implements OnInit, OnDestroy {
  cbsForm: FormGroup;
  branches = [];
  companys = [];
  permissionKey = [];
  permissionJson: Map<String, String[]>;
  role = localStorage.getItem(KEYS.ROLE);
  loggedInUser: any;
  subscription = new Subscription();
  userNotificationCriteria: IUserNotificationCriteria = { enableLoader: false };
  loaderCriteria: ILoader = { enableLoader: false };
  unsubTimeout: any;
  readonly heartBeatTime = 15000;
  readonly reconnectDelay = 60000;

  @ViewChild('accordion') accordion: MatAccordion;
  @Input() valueChanged;

  public isToggle: boolean = false; public menuItem: any = []; dashboardPath: string = "dashboard";
  isdisabled = false;
  searchText: string = "";
  deviceType: DeviceType;

  constructor(
    private Emitter: EventEmitterService,
    private router: Router,
    private logger: NGXLogger,
    private formBuilder: FormBuilder,
    private service: DataService,
    private dailog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private layoutService: LayoutService,
    private toaster: ToastrService,
    private locationStrategy: LocationStrategy,
    private deviceDetectorService: DeviceDetectorService,
    private idleService: IdleService,
  ) {
    this.isUserLoggedOutEvent();
    this.deviceDetectorService.deviceType$.subscribe((deviceType: DeviceType) => {
      this.deviceType = deviceType;
    });
    this.deviceType = this.deviceDetectorService.getCurrentDeviceType();
  }
  ngOnInit() {
    this.initializeCbsForm();
    this.detectValueChanges();
    this.companyId = localStorage.getItem(KEYS.COMPANY_ID);
    this.branchId = localStorage.getItem(KEYS.BRANCH_ID);
    this.addValidator();
    this.getUserCompanies();
    if (sessionStorage.getItem("Role") == "GsaUser") {
      this.dashboardPath = "gsa-dashboard";
    }

    this.menuItem = MenuItem;
    this.logger.info("menu item data : ", this.menuItem);
    this.allPermissionKeys;
    this.isToggle = this.Emitter.getLastToggleValue();

    this.Emitter.invokeToggle.subscribe((state: boolean) => {
    this.toggle(state);
  });
    this.getLoggedInUser();
  }

  private getLoggedInUser() {
    this.service.get(Api.LOGGED_IN_USER).subscribe(res => {
      if (res) {
        this.loggedInUser = res;
        this.logger.info("loggedInUser", this.loggedInUser);
        this.checkForNewNotification(this.loggedInUser.id, this.heartBeatTime);
      }
    })
  }

  private checkForNewNotification(userId: number, time: number) {
    this.userNotificationCriteria.receiverUserId = userId;
    this.userNotificationCriteria.isRead = false;
    clearTimeout(this.unsubTimeout);
    const checkForNotif = interval(time).subscribe(() => {
      this.service.get(`${Api.USER_CHECK_FOR_NEW_NOTIFICATION}/${userId}`, this.loaderCriteria).subscribe((status: boolean) => {
        if (status) {
          this.getUserNotification();
        }
      }, err => { checkForNotif.unsubscribe(); this.reconnectAfterDelay(this.reconnectDelay) })
    })
    this.subscription.add(checkForNotif);
  }

  reconnectAfterDelay(delay: number) {
    this.logger.info(`Error occured while fetching User Notifications. Retrying after ${this.reconnectDelay} ms`);
    this.unsubTimeout = setTimeout(() => {
      this.checkForNewNotification(this.loggedInUser.id, this.heartBeatTime);
    }, delay);
  }

  getUserNotification() {
    this.service.get(Api.USER_NOTIFICATION_FOR_DD, this.userNotificationCriteria).subscribe((notifications: IUserNotificationDto[]) => {
      this.logger.info("user notifications", notifications);
      if (notifications.length > 0) {
        notifications.forEach(message => {
          this.toaster.info(
            this.getNotificationFormat(message), message.title, { closeButton: true, disableTimeOut: true, enableHtml: true }
          );
        });
        this.setIsReadTrue(notifications);
      }
    });
  }

  getNotificationFormat(message: IUserNotificationDto): string {
    const text =
      `To:${message.receiverUserName}<br>
    From: ${message.senderUserName}<br> 
    On: ${this.getFormattedDate(message.timeStamp)}<br>
    Message:<br>${message.messageContent}`;
    return text;
  }

  setIsReadTrue(notifications: IUserNotificationDto[]) {
    this.service.put(Api.USER_NOTIFICATION_READ_TRUE, notifications, this.loaderCriteria).subscribe(res => { });
  }

  getFormattedDate(timeStamp: string) {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    };
    return new Date(timeStamp).toLocaleString('en-US', options).replace(',', ' At').replace(/\//g, '-');
  }

  ngOnDestroy(): void {
    clearTimeout(this.unsubTimeout);
    this.subscription.unsubscribe();
  }

  private detectValueChanges() {
    this.layoutService.companyBranchChanged.subscribe((value) => {
      if (value === 'valueChanged') {
        if (localStorage.getItem(KEYS.COMPANY_ID)) {
          this.companyId = localStorage.getItem(KEYS.COMPANY_ID);
          this.logger.info('Inside Company');
        } else {
          this.cbsForm.get('company').setValue(null);
          this.logger.info('Outside Company', this.companyId);
        }
        if (localStorage.getItem(KEYS.BRANCH_ID)) {
          this.logger.info('Inside Branch');
          this.branchId = localStorage.getItem(KEYS.BRANCH_ID);
        } else {
          this.cbsForm.get('branch').setValue(null);
        }
        this.logger.info('Company Id in side bar ', this.companyId);
        this.logger.info('branch Id in side bar ', this.branchId);
      }
    });
  }

  logout() {
    const dailogRef = this.dailog.open(ConfirmDailogueComponent, {
      data: 'Are you sure you want logout?',
      maxWidth: "300px",
      maxHeight: "150px"
    });

    dailogRef.afterClosed().subscribe(dailogResult => {
      if (dailogResult === false) return;
      else this.clearStorageDataAndNavigateToLoginPage();
      
    })
  }

  private clearStorageDataAndNavigateToLoginPage(){
    this.idleService.stop();
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/login';
  }

  toggle(isToggle: boolean) {
    this.isToggle = isToggle;
  }
  private initializeCbsForm() {
    this.createFormGroup();
    this.setCompanyChangeEvent();
    this.setBranchChangeEvent();
  }

  private addValidator() {
    const role = localStorage.getItem(KEYS.ROLE);
    if (role === "ROLE_BSA" || role === "ROLE_USER") {
      this.cbsForm.get("branch").setValidators(Validators.required);
    }
  }

  private createFormGroup() {
    this.cbsForm = this.formBuilder.group({
      company: [],
      branch: [],
    });
  }

  private setCompanyChangeEvent() {
    this.cbsForm.get("company").valueChanges.subscribe((companyIdValue) => {
      if (companyIdValue) {
        localStorage.setItem(KEYS.COMPANY_ID, companyIdValue);
        this.getBranchesByCompanyId(companyIdValue);
      } else {
        localStorage.removeItem(KEYS.COMPANY_ID);
      }
    });
  }

  private setBranchChangeEvent() {
    this.cbsForm.get("branch").valueChanges.subscribe((branchIdValue) => {
      if (branchIdValue) {
        localStorage.setItem(KEYS.BRANCH_ID, branchIdValue);
      } else {
        localStorage.removeItem(KEYS.BRANCH_ID);
      }
    });
  }

  private getUserCompanies() {
    this.service.get(Api.USER_COMPANY_LIST).subscribe((res) => {
      this.logger.info("company list res", res);
      if (res) {
        this.companys = res;
      }
    });
  }

  getBranchesByCompanyId(companyId) {
    this.branches = [];
    if (companyId === null || companyId === undefined) {
      return;
    }
    this.service.get(Api.USER_COMPANY_BRANCH_LIST + companyId).subscribe((res) => {
      this.logger.info("company Branch res", res);
      if (res) {
        this.branches = res;
      }
    });
  }

  private refreshPage() {
    this.logger.info("location", this.router.url);
    let currentUrl = this.router.url;
    this.router.navigateByUrl(".", { skipLocationChange: true });
    this.router
      .navigateByUrl("/dashboard", { skipLocationChange: false })
      .then(() => this.router.navigateByUrl(currentUrl));
  }

  onChange() {
    this.dailog.open(CompanyBranchSelectionComponent, {
      panelClass: 'company-branch-dialog-panel',
      backdropClass: 'company-branch-dialog-backdrop',
      hasBackdrop: true
    });
  }

  get companyId() {
    return this.cbsForm.get("company")?.value;
  }

  get branchId() {
    return this.cbsForm.get("branch")?.value;
  }

  set companyId(companyId) {
    if (!companyId) {
      return;
    }
    this.cbsForm.get("company").setValue(+companyId);
  }

  set branchId(branchId) {
    if (!branchId) {
      return;
    }
    this.cbsForm.get("branch").setValue(+branchId);
  }

  get allPermission() {
    var permissionJson = JSON.parse(localStorage.getItem(KEYS.PERMISSION_DATA));
    this.logger.info("permission ---->  : ", permissionJson);
    let permissionMap = new Map<string, any>();
    for (var value in permissionJson) {
      permissionMap.set(value, permissionJson[value]);
    }
    return permissionMap;
  }

  get allPermissionKeys() {
    this.permissionKey = Array.from(this.allPermission.keys());
    this.logger.info("permission data keys  :", this.permissionKey);
    return this.permissionKey;
  }

  /**
   * True while the menu search box has text. Drives [expanded] on every
   * group panel: the filter pipe only leaves groups that matched, so
   * whatever was searched for is inside one of them and the panel should
   * already be open rather than needing a second click.
   */
  get isSearching(): boolean {
    return !!this.searchText?.trim();
  }

  /**
   * checkPermission
   */
  public checkPermission(permission: string) {
    if(TrackingOutputModuleName.OPEN_TRACKING_MODULE === permission){
      return true;
    } else if (PermissionKey.CARGO_MANAGEMENT_PROCESS === permission) {
      // Cargo Management's menu entry is always visible regardless of permission - actual page
      // access is separately gated inside CargoManagementComponent itself via
      // PermissionKey.CARGO_MANAGEMENT_PROCESS_VIEW, not by hiding the menu item.
      return true;
    } else if (this.permissionKey.includes(permission)) {
      return true;
    } else {
      return false;
    }
  }

  
  navigateOnClick(route: any, isLeftClick:boolean){
    if(route){
      const routeurl = this.activatedRoute.snapshot['_routerState'].url;
      if (isLeftClick && (routeurl.includes('/add') || routeurl.includes('/edit'))) {
        this.openDailog(Message.ON_LEFT_SIDE_MENU_CLICK, route);
      } else {
        this.isToggle = false;
        this.Emitter.onToggle(this.isToggle);
        isLeftClick ? this.router.navigate([route]) : this.openNewTab(route);
      }
    }
  }

  openNewTab(partialUrl: string) {
    const urlTree = this.router.createUrlTree([partialUrl]);
    const url = this.router.serializeUrl(urlTree);
    const fullUrl = this.locationStrategy.prepareExternalUrl(url);
    window.open(fullUrl, '_blank');
  }

  isLinkActive(route: string): boolean {
    const currentRoute = this.router.url;
    return currentRoute === route;
  }

  openDailog(message: string, navigate: any) {
    const dailogRef = this.dailog.open(ConfirmDailogueComponent, {
      data: message, maxWidth: "300px", maxHeight: "150px"
    });
    dailogRef.afterClosed().subscribe(dailogResult => {
      if (dailogResult === false) return;
      else this.router.navigate([navigate]);
    })
  }

  // Temporary Feature
  // clearCache(){
  //   this.service.get(Api.CLEAR_CACHE).subscribe(res =>{
  //     if(res) this.logger.info(res);
  //   })
  // }

  openTracking(){
   this.openNewTab(APP_ROUTES.TRACKING_OUTPUT);
  }

  private isUserLoggedOutEvent(){
    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
        let token = localStorage.getItem('ACCESS_TOKEN');
        if(token == undefined) {
          this.clearStorageDataAndNavigateToLoginPage();
        }
      }
    }, false);
  }
}

